/**
 * Marketing image URLs for TMOS Vision page
 * These are placeholder URLs from Unsplash that match the desired themes.
 * Replace these with actual images when available.
 */

export const marketingImages = {
  /** Public home — Built for your organization (3 cards). Replace with brand assets when ready. */
  landingOrganization: {
    peFirms:
      'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=800&h=500&fit=crop&q=80',
    peBacked:
      'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&h=500&fit=crop&q=80',
    consultants:
      'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&h=500&fit=crop&q=80',
  },

  // Hero section - Bright financial/Wall Street
  hero: {
    office: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=1200&h=800&fit=crop&q=80', // Bright modern office
    executives: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=1200&h=800&fit=crop&q=80', // Bright business meeting
    financial: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&h=800&fit=crop&q=80', // Bright financial charts
  },
  
  // Challenges section - Bright, varied images
  challenges: {
    fragmented: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&h=600&fit=crop&q=80', // Bright team workspace
    blindSpots: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=800&h=600&fit=crop&q=80', // Bright collaboration
    noTruth: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=600&fit=crop&q=80', // Bright data visualization
  },
  
  // Pillars section - Bright, unique images
  pillars: {
    alignment: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=600&fit=crop&q=80', // Bright charts/alignment
    governance: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&h=600&fit=crop&q=80', // Bright professional office
    partnership: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=800&h=600&fit=crop&q=80', // Bright executive partnership
  },
  
  // Engagement models - Bright, distinct images
  engagement: {
    platform: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&h=600&fit=crop&q=80', // Bright modern office
    assistance: 'https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=800&h=600&fit=crop&q=80', // Bright team meeting
    consulting: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=800&h=600&fit=crop&q=80', // Bright consulting session
    outcome: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=600&fit=crop&q=80', // Bright financial success
  },
  
  // Impact section - Bright financial themes
  impact: {
    speed: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=600&fit=crop&q=80', // Bright growth charts
    reuse: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&h=600&fit=crop&q=80', // Bright efficiency
    governance: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&h=600&fit=crop&q=80', // Bright Wall Street
  },
  
  // CTA section - Bright blue sky / aspirational
  cta: {
    blueSky: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1200&h=800&fit=crop&q=80', // Bright blue sky
    wallStreet: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1200&h=800&fit=crop&q=80', // Bright Wall Street
  },
  
  // Background images - Bright versions
  backgrounds: {
    officeSpace: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=1920&h=1080&fit=crop&q=80', // Bright modern office
    financial: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1920&h=1080&fit=crop&q=80', // Bright financial charts
    blueSky: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1920&h=1080&fit=crop&q=80', // Bright blue sky
    executives: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=1920&h=1080&fit=crop&q=80', // Bright executives
  },
};
